import { ACTION, ACTION_SUBJECT, EVENT_TYPE } from '@atlaskit/editor-common/analytics/types/enums';
import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types/next-editor-plugin';

import type { AIPlugin } from '../../aiPluginType';

/**
 * Fire an analytics event when the ai-quick-prompt is displayed to the user.
 */
export function fireAiQuickPromptDisplayedEvent({
	api,
	experienceName,
}: {
	api: ExtractInjectionAPI<AIPlugin> | undefined;
	experienceName: string;
}): void {
	api?.analytics?.actions?.fireAnalyticsEvent({
		action: ACTION.DISPLAYED,
		actionSubject: ACTION_SUBJECT.AI_QUICK_PROMPT,
		eventType: EVENT_TYPE.UI,
		attributes: {
			experienceName,
		},
	});
}

/**
 * Fire an analytics event when the user triggers the ai-quick-prompt (Tab).
 */
export function fireAiQuickPromptTriggeredEvent({
	api,
	experienceName,
	method,
}: {
	api: ExtractInjectionAPI<AIPlugin> | undefined;
	experienceName: string;
	method: string;
}): void {
	api?.analytics?.actions?.fireAnalyticsEvent({
		action: ACTION.TRIGGERED,
		actionSubject: ACTION_SUBJECT.AI_QUICK_PROMPT,
		eventType: EVENT_TYPE.UI,
		attributes: {
			experienceName,
			method,
		},
	});
}

/**
 * Fire an analytics event when there is a backend API error during the
 * ai-quick-prompt should-improve-writing check.
 */
export function fireAiQuickPromptApiErrorEvent({
	api,
	experienceName,
	errorMessage,
	statusCode,
}: {
	api: ExtractInjectionAPI<AIPlugin> | undefined;
	errorMessage?: string;
	experienceName: string;
	statusCode?: number;
}): void {
	api?.analytics?.actions?.fireAnalyticsEvent({
		action: ACTION.API_ERROR,
		actionSubject: ACTION_SUBJECT.AI_QUICK_PROMPT,
		eventType: EVENT_TYPE.OPERATIONAL,
		attributes: {
			experienceName,
			...(statusCode !== undefined ? { statusCode } : {}),
			...(errorMessage !== undefined ? { errorMessage } : {}),
		},
	});
}

/**
 * Fire an analytics event when the user dismisses the ai-quick-prompt (Escape).
 */
export function fireAiQuickPromptDismissedEvent({
	api,
	experienceName,
	method,
}: {
	api: ExtractInjectionAPI<AIPlugin> | undefined;
	experienceName: string;
	method: string;
}): void {
	api?.analytics?.actions?.fireAnalyticsEvent({
		action: ACTION.DISMISSED,
		actionSubject: ACTION_SUBJECT.AI_QUICK_PROMPT,
		eventType: EVENT_TYPE.UI,
		attributes: {
			experienceName,
			method,
		},
	});
}
